<template>
  <div class="top-nav">
    <el-menu
      :active-text-color="variables.menuActiveText"
      :default-active="activeMenu"
      mode="horizontal"
      @select="handleSelect"
      class="top-nav-li"
    >
      <div v-for="item in routes" :key="item.path" class="nav-item">
        <app-link v-if="!item.hidden" :to="resolvePath(item)">
          <el-menu-item
            class="nav-item-li"
            :index="item.path === '/' ? resolvePath(item) : item.path"
          >
            <i :class="'iconfont ' + (item.meta && item.meta.icon)"></i>
            <span>{{
              item.meta ? item.meta.title : item.children[0].meta.title
            }}</span>
            <!-- <item
              :icon="'iconfont ' + (item.meta && item.meta.icon)"
              :title="item.meta ? item.meta.title : item.children[0].meta.title"
            /> -->
            <div></div>
          </el-menu-item>
        </app-link>
      </div>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppLink from "./Sidebar/Link";
import { constantRoutes } from "@/router";
import variables from "@/styles/variables.scss";
import { isExternal } from "@/utils/validate";
import Item from "./Sidebar/Item";

export default {
  name: "Topbar",
  components: {
    AppLink,
    Item,
  },
  data() {
    return {
      routes: constantRoutes,
    };
  },
  computed: {
    activeMenu() {
      const route = this.$route;
      this.initCurrentRoutes();
      const { meta, path } = route;
      if (meta.activeMenu) {
        return "/" + meta.activeMenu.split("/")[1];
        // return meta.activeMenu;
      }
      // 如果是首页，首页高亮
      if (path === "/dashboard") {
        return "/";
      }
      // 如果不是首页，高亮一级菜单
      const activeMenu = "/" + path.split("/")[1];
      return activeMenu;
    },
    variables() {
      return variables;
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    ...mapGetters(["avatar"]),
  },
  mounted() {
    this.initCurrentRoutes();
  },
  methods: {
    // 通过当前路径找到二级菜单对应项，存到store，用来渲染左侧菜单
    initCurrentRoutes() {
      const { meta, path } = this.$route;
      let route = "";
      if (meta.activeMenu) {
        route = this.routes.find(
          (item) => item.path === "/" + meta.activeMenu.split("/")[1]
        );
        // return "/" + meta.activeMenu.split("/")[1];
        // return meta.activeMenu;
      } else {
        route = this.routes.find(
          (item) => item.path === "/" + path.split("/")[1]
        );
      }
      // 如果找不到这个路由，说明是首页
      if (!route) {
        route = this.routes.find((item) => item.path === "/");
      }
      this.$store.commit("permission/SET_CURRENT_ROUTES", route);
      this.setSidebarHide(route);
    },
    // 判断该路由是否只有一个子项或者没有子项，如果是，则在一级菜单添加跳转路由
    isOnlyOneChild(item) {
      if (item.children && item.children.length === 1) {
        return true;
      }
      return false;
    },
    resolvePath(item) {
      // 如果是个完成的url直接返回
      if (isExternal(item.path)) {
        return item.path;
      }
      // 如果是首页，就返回重定向路由
      if (item.path === "/") {
        const path = item.redirect;
        return path;
      }

      // 如果有子项，默认跳转第一个子项路由
      let path = "";
      /**
       * item 路由子项
       * parent 路由父项
       */
      const getDefaultPath = (item, parent) => {
        // 如果path是个外部链接（不建议），直接返回链接，存在个问题：如果是外部链接点击跳转后当前页内容还是上一个路由内容
        if (isExternal(item.path)) {
          path = item.path;
          return;
        }
        // 第一次需要父项路由拼接，所以只是第一个传parent
        if (parent) {
          path += parent.path + "/" + item.path;
        } else {
          path += "/" + item.path;
        }
        // 如果还有子项，继续递归
        if (item.children) {
          getDefaultPath(item.children[0]);
        }
      };

      if (item.children) {
        getDefaultPath(item.children[0], item);
        return path;
      }

      return item.path;
    },
    handleSelect(key, keyPath) {
      // 把选中路由的子路由保存store
      const route = this.routes.find(
        (item) => item.path === key || item.redirect === key
      );
      this.$store.commit("permission/SET_CURRENT_ROUTES", route);
      this.setSidebarHide(route);
    },
    // 设置侧边栏的显示和隐藏
    setSidebarHide(route) {
      // if (!route.children || route.children.length === 1) {
      //   this.$store.dispatch("app/toggleSideBarHide", true);
      // } else {
      //   this.$store.dispatch("app/toggleSideBarHide", false);
      // }
    },
  },
};
</script>

<style lang="scss"  scoped>
#app .top-nav {
  width: auto;
  height: 60px;
  display: flex;display:-webkit-flex;
  align-items: center;
  &-li {
    width: auto;
    height: 60px;
    display: flex;display:-webkit-flex;
    align-items: center;
    border: 0;
  }
  .nav-item {
    width: auto;
    height: 60px;
    position: relative;
    .nav-item-li.is-active,
    .nav-item-li:hover {
      background-color: #4e95f8 !important;
      > div {
        width: 30px;
        height: 3px;
        background: #ffffff;
        border-radius: 5px;
        position: absolute;
        bottom: 10px;
        left: calc(50% - 15px);
        z-index: 1;
      }
    }
    .nav-item-li {
      width: auto;
      height: 60px;
      background-color: #1677ff !important;
      border-radius: 0;
      span {
        color: #fff;
        font-size: 16px;
        font-weight: 400;
      }
      .iconfont {
        color: #fff;
      }
    }
  }
}
</style>